import type { AxiosError } from 'axios'

import axios from 'axios'

import env from 'env'

import { request } from '../request'
import { extractResponseData } from '../utils'

const userApiInstance = axios.create({
  baseURL: env.USER_API_BASE_URL,
})

userApiInstance.interceptors.request.use(request)
userApiInstance.interceptors.response.use(extractResponseData, (error: AxiosError) =>
  Promise.reject(error.response ?? error),
)

export { userApiInstance }
